/* eslint-disable import/prefer-default-export */

/**
 * @type {String}
 */
export const CLASS_NAME = 'priority-badge-manager';
